import { MEDIA_CODE, MEDIA_NAME, PAGE_NM } from '../types/types';
import { useRecoilState } from 'recoil';
import * as Atom from '../recoil';
import { fetchBaseUserAgreed } from '../../infra/api/fetchBaseUserAgreed';
import { useBridge as Bridge } from './useBridge';
import { putLoanAgreeInfo } from '../../infra/api';
import useNav from './useNav';
import { useBaseParam } from './useBaseParam';
import useToast from './useToast';

const useTermsBloc = (media?: string, ref_page?: string) => {
  return media === MEDIA_NAME.SKT
    ? SktTerm(ref_page)
    : media === MEDIA_NAME.KT
    ? KtTerm(ref_page)
    : media === MEDIA_NAME.LGU
    ? LguTerm(ref_page)
    : {};
};

const useBaseInfoFromRecoil = () => {
  const [userInfo] = useRecoilState(Atom.userInfo);
  const [personalInfo, setPersonal] = useRecoilState(Atom.personalInfo);
  const { navigate } = useNav();

  return { userInfo, personalInfo, setPersonal, navigate };
};

const SktTerm = (ref_page?: string) => {
  const { userInfo, personalInfo, setPersonal } = useBaseInfoFromRecoil();
  const ShowTerms = () => {};

  const condition = {
    mediaCd: MEDIA_CODE.SKT,
    certYn: 'Y',
    passYn: 'Y',
    bankYn: 'Y',
    credYn: 'Y',
    contYn: 'Y',
    srcCd: userInfo.srcCd,
    ctn: userInfo.ctn,
    mgntCd: userInfo.mgntCd,
    agreeType: ref_page === PAGE_NM.MTG_HOME ? '02' : '01',
  };
  const wrappedLoanAgreeInfo = useBaseParam(putLoanAgreeInfo, condition);

  const SubmitAgree = async () => {
    const res = await wrappedLoanAgreeInfo();
    if (res?.data?.isSucceed) {
      setPersonal((prev: any) => {
        return {
          ...prev,
          transactionNo: res?.data?.result.transactionNo,
          cellNo: res?.data?.result.ctn,
          custNm: res?.data?.result.custNm,
          birthDt: res?.data?.result.birthDt,
          gender: res?.data?.result.gender,
          ctn: res?.data?.result.ctn,
          custSeq: res?.data?.result.custSeq,
          isAgreed: res?.data?.result.isAgreed,
          tester: res?.data?.result.tester ?? false,
        };
      });
      return { isSuccess: true, custSeq: res?.data?.result.custSeq };
    } else {
      return { isSuccess: false };
    }
  };

  return { show: ShowTerms, agree: SubmitAgree };
};

const KtTerm = (ref_page?: string) => {
  const { personalInfo, setPersonal } = useBaseInfoFromRecoil();
  const br: any = Bridge();
  const { addToast } = useToast();

  const ShowTerms = () => {};
  const SubmitAgree = () => {
    return new Promise((resolve) => {
      br.onReceiveCustomerInfo(
        async (
          joinType: any,
          passAppId: any,
          custCi: any,
          cphoneNo: any,
          custBirth: any,
          custNm: any,
          custGender: any,
          phoneType: any,
          custNativeYn: any,
          telecomType: any,
        ) => {
          const condition = {
            certYn: 'Y',
            passYn: 'Y',
            bankYn: 'Y',
            credYn: 'Y',
            contYn: 'Y',
            mediaCd: MEDIA_CODE.KT,
            joinType,
            passAppId,
            custCi,
            cphoneNo,
            custBirth,
            custNm,
            custGender,
            phoneType,
            custNativeYn,
            telecomType,
            agreeType: ref_page === PAGE_NM.MTG_HOME ? '02' : '01',
          };
          const res = await putLoanAgreeInfo({
            trackCd: personalInfo.trackCd,
            transactionNo: personalInfo.transactionNo,
            authToken: personalInfo.authToken,
            condition,
          });
          if (!res.data.isSucceed && res.data.resultMessage) {
            addToast(res.data.resultMessage);
            return;
          }
          const result = res?.data?.result;

          if (result) {
            setPersonal((prev: any) => {
              return {
                ...prev,
                custNm: result.custNm,
                birthDt: result.birthDt,
                gender: result.gender,
                transactionNo: result.transactionNo,
                ctn: result.ctn,
                cellNo: result.ctn,
                custSeq: result.custSeq,
              };
            });
            resolve({ isSuccess: true, custSeq: result.custSeq });
          } else {
            resolve({ isSuccess: false });
          }
        },
      );
      br.requestCustomerInfo({ thirdLoanYn: 'Y' });
    });
  };

  return { show: ShowTerms, agree: SubmitAgree };
};

const LguTerm = (ref_page?: string) => {
  const { userInfo, setPersonal } = useBaseInfoFromRecoil();
  const br: any = Bridge();
  const getBaseUserAgreed = useBaseParam(fetchBaseUserAgreed, {
    appUserId: userInfo.appUserId,
    appUserPartIdx: userInfo.appUserPartIdx,
    agreeType: ref_page === PAGE_NM.MTG_HOME ? '02' : '01',
  });

  const ShowTerm = async (state?: any) => {
    const res: any = await getBaseUserAgreed();

    const { custNm, birthDt, gender, transactionNo, ctn, custSeq, isAgreed, tester } =
      res?.data?.result;

    if (isAgreed) {
      setPersonal((prev: any) => {
        return {
          ...prev,
          custNm: custNm,
          birthDt: birthDt,
          gender: gender,
          transactionNo: transactionNo,
          ctn: ctn,
          cellNo: ctn,
          custSeq: custSeq,
          tester: tester ?? false,
        };
      });
      // isSuccess true 반환 시 바로 step1 이동
      return {
        isSuccess: isAgreed,
        resultCode: res?.data?.resultCode,
        resultMessage: res?.data?.resultMessage,
        custSeq: custSeq,
      };
    } else if (!isAgreed) {
      return new Promise((resolve) => {
        br.onCloseNativeTerm(async (isAgreeYn: any, buttonType: any) => {
          if (isAgreeYn === 'Y' && buttonType === 'A') {
            const res: any = await getBaseUserAgreed();

            const {
              custNm,
              birthDt,
              gender,
              transactionNo,
              ctn,
              custSeq,
              isAgreed,
            } = res?.data?.result;

            setPersonal((prev: any) => {
              return {
                ...prev,
                custNm: custNm,
                birthDt: birthDt,
                gender: gender,
                transactionNo: transactionNo,
                ctn: ctn,
                cellNo: ctn,
                custSeq: custSeq,
              };
            });
            resolve({
              isSuccess: isAgreed,
              resultCode: res?.data?.resultCode,
              resultMessage: res?.data?.resultMessage,
              custSeq: custSeq,
            });
          } else {
            resolve({
              isSuccess: false,
              resultMessage: '약관 동의하지 않고 화면 닫힘',
            });
          }
        });
        br.showTerms();
      });
    } else {
      return;
    }
  };
  return { show: ShowTerm };
};

export default useTermsBloc;
